module.exports = __webpack_public_path__ + "img/yunLive.f4606d37.png";